import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import './styles.scss';
import Button from '../buttons/Button';
import formatPrice from '../../services/formatPrice';
import checkNaN from '../../services/checkNaN';

const LeasingRateBox = ( props ) => {
    let [ checkOne, setCheckOne ] = useState('Quarterly 4 times a year');
    let [ forceValidate, setForceValidate ] = useState(false);
    let [ load, setLoad ] = useState(false);
    let [ clickedButton, setClickedButton ] = useState(0);
    let [ price12, setPrice12 ] = useState(0);
    let [ price4, setPrice4 ] = useState(0);
    let [ errors, setErrors ] = useState(false);


    const dispatch = useDispatch()
    let rateFrequency       = useSelector(state => state.rateFrequency);
    let allowForm           = useSelector(state => state.allowForm);
    let rate                = useSelector(state => state.rate);
    let finalRate           = useSelector(state => state.finalRate);
    let chargePrice         = useSelector(state => state.chargePrice)
    let tax                 = useSelector(state => state.tax); 
    let productPriceEnd     = useSelector(state => state.productPriceEnd); 
    let productPrice        = useSelector(state => state.productPrice); 
    let activeContract      = useSelector(state => state.selectedLease); 

    // useEffect(() => {
    //     console.log(rateFrequency)
    // }, [rateFrequency])
    // useEffect(() => {
    //     console.log(finalRate)
    // }, [finalRate])

    let validate = async () => {
        if ( checkOne.length === 0) {
            await setErrors(true);
        } else {
            await setErrors(false);
        }
    }

    useEffect(() => {
        if ( props.forceValidate ) {
            validate();
        }
    }, [props.forceValidate])

    useEffect(() => {
        if ( clickedButton > 0 ) {
            props.changePage();
        }
    }, [clickedButton])

    useEffect(() => {
        if ( (!load && rateFrequency.length > 0 && props.price4 > 0) || (!load && rateFrequency.length > 0 && props.price12 > 0)) {
            if ( rateFrequency == 'kwartalnie') {
                setCheckOne('Quarterly 4 times a year')
            }
            if ( rateFrequency == 'miesięcznie') {
                setCheckOne('Monthly 12 monthly installments')
            }
            setLoad(true);
        }
        
    }, [load, rateFrequency, props.price4, props.price12])

    useEffect(() => {
        if ( checkOne.length > 0 ) {
            setForceValidate(false);
            setErrors(false);

            if(props.price4 > 0) {
                if ( checkOne == 'Quarterly 4 times a year' ) {
                    dispatch({ type: 'FINAL_RATE_CHANGE', value: props.price4 })
                    dispatch({ type: 'RATE_FREQUENCY_CHANGE', value: 'kwartalnie' })
                }
            }
            if(props.price12 > 0) {
                if ( checkOne == 'Monthly 12 monthly installments' ) {
                    dispatch({ type: 'FINAL_RATE_CHANGE', value: props.price12 })
                    dispatch({ type: 'RATE_FREQUENCY_CHANGE', value: 'miesięcznie' })
                }
            }
        }
    }, [checkOne, props.price4, props.price12])

    return (
        <div className="leasing-rate-box">
            {/* <p className={"leasing-head" + ( errors ? ' error-item':'')}>Wybierz interesującą Cię ratę</p> */}
            <div className="wrapper">
                    { rate.indexOf('kwartalna') > -1 &&
                        <>
                            { props.activeRate4 && 
                                <>
                                    <div className={"row rectangle-item" + ( checkOne === 'Quarterly 4 times a year' ? ' active': '') } onClick={ () => setCheckOne( 'Quarterly 4 times a year' ) }>
                                        <div className="text-rate">
                                            <div className="radius-icon" />
                                            <p><strong>Quarterly</strong> 4 times a year</p>
                                        </div>
                                        {props.price4 &&
                                            <div className="price">
                                                <p><strong>{ checkNaN(formatPrice(props.price4)) }</strong> net</p>
                                            </div>
                                        }
                                    </div>
                                </>
                            }
                        </>
                    }
                    
                    { rate.indexOf('miesieczna') > -1 &&
                        <>
                            <div className={"row rectangle-item" + ( checkOne === 'Monthly 12 monthly installments' ? ' active': '') } onClick={ () =>  setCheckOne( 'Monthly 12 monthly installments' ) }>
                                <div className="text-rate">
                                    <div className="radius-icon" />
                                    <p><strong>Monthly</strong> 12 installments</p>
                                </div>
                                {props.price12 &&
                                    <div className="price">
                                        <p><strong>{ checkNaN(formatPrice(props.price12)) }</strong> net</p>
                                    </div>
                                }
                            </div>
                            
                        </>
                    }

                    <div className="values">
                        <div className="value">
                            <p>Administration fee</p>
                            <p>{ tax }</p>
                        </div>
                        {/* <div className="value">
                            <> 
                                { tax != '0,00 zł' &&
                                    <>
                                        <p>Opłata za opracowanie:</p>
                                        <p>{ tax } netto</p>
                                    </>
                                }
                                
                            </>
                        </div>
                        <div className="value">
                            <p>Opłata początkowa:</p>
                            <p>{ chargePrice } netto</p>
                        </div>
                        {activeContract == "tradycyjny" &&
                            <div className="value">
                                <p>Wartość końcowa:</p>
                                <p>{  allowForm && !( checkNaN(formatPrice(props.price12)) != '0,00 zł' && !checkNaN(formatPrice(props.price4)) != '0,00 zł' ) ?  '0,00 zł' : productPriceEnd } netto</p>
                            </div>
                        } */}
                        {/* { tax == '0,00 zł' &&
                            <p className='big-text'>Opłata za opracowanie 0 zł</p>
                        } */}
                    </div>

                    

                    <div className="texta">{ props.text }</div>
                    {/* { !allowForm && !( checkNaN(formatPrice(props.price12)) != '0,00 zł' && !checkNaN(formatPrice(props.price4)) != '0,00 zł' ) && 
                        <div className="texta red error-item">Parametry nieobsługiwane dla tego rodzaju sprzętu. Skontaktuj się z GRENKE.</div>
                    } */}
                    
                    {/* { allowForm  && 
                        <div className="buttons-wrap">
                            <Button title="Wypełnij wniosek online" 
                                    class="blue" 
                                    arrow={ true } 
                                    setFunction={ async () => { await setClickedButton(++clickedButton); } } />
                        </div>
                    } */}
                    {/* { allowForm && !( checkNaN(formatPrice(props.price12)) != '0,00 zł' && !checkNaN(formatPrice(props.price4)) != '0,00 zł' ) && 
                        <div className="texta red error-item">Parametry nieobsługiwane dla tego rodzaju sprzętu lub kwoty. Skontaktuj się z GRENKE.</div>
                    } */}
                    
                    { allowForm && ( checkNaN(formatPrice(props.price12)) != '0,00 AED' && checkNaN(formatPrice(props.price4)) != '0,00 AED' ) &&  
                        <div className="buttons-wrap">
                            {/* <Button title="Powórt" class="reverse blue border-white" arrowPrev={ true } /> */}
                            <Button title="Fill out the application" 
                                    // disabled={ !checkOne || !checkOne.length === 0 }
                                    class="black" 
                                    arrow={ true } 
                                    setFunction={ async () => { await setClickedButton(++clickedButton); } } />
                        </div>
                    }
                    { allowForm && !( checkNaN(formatPrice(props.price12)) != '0,00 AED' && !checkNaN(formatPrice(props.price4)) != '0,00 AED' ) && 
                        <div className="texta red error-item">Parameters not supported for this type of equipment or amount. Please contact GRENKE: +971 4 873 5900</div>
                    }
            </div>
        </div>
    )
}

export default LeasingRateBox;